/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const customerDetailResponseOutputIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const customerDetailResponseOutputVersionExclusiveMin = 0;
export const customerDetailResponseOutputVersionMax = 9007199254740991;

export const customerDetailResponseOutputCreatedAtRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const customerDetailResponseOutputUpdatedAtRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const customerDetailResponseOutputArchivedAtOneRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const customerDetailResponseOutputAssignmentCountMin = 0;
export const customerDetailResponseOutputAssignmentCountMax = 9007199254740991;

export const customerDetailResponseOutputKnownNumberCountMin = 0;
export const customerDetailResponseOutputKnownNumberCountMax = 9007199254740991;

export const CustomerDetailResponseOutput = zod.object({
  id: zod.uuid().regex(customerDetailResponseOutputIdRegExp),
  name: zod.string(),
  status: zod.enum(['active', 'archived']),
  version: zod
    .int()
    .gt(customerDetailResponseOutputVersionExclusiveMin)
    .max(customerDetailResponseOutputVersionMax),
  createdAt: zod.iso.datetime({ offset: true }).regex(customerDetailResponseOutputCreatedAtRegExp),
  updatedAt: zod.iso.datetime({ offset: true }).regex(customerDetailResponseOutputUpdatedAtRegExp),
  archivedAt: zod.union([
    zod.iso.datetime({ offset: true }).regex(customerDetailResponseOutputArchivedAtOneRegExp),
    zod.null(),
  ]),
  assignmentCount: zod
    .int()
    .min(customerDetailResponseOutputAssignmentCountMin)
    .max(customerDetailResponseOutputAssignmentCountMax),
  knownNumberCount: zod
    .int()
    .min(customerDetailResponseOutputKnownNumberCountMin)
    .max(customerDetailResponseOutputKnownNumberCountMax),
});

export type CustomerDetailResponseOutput = zod.input<typeof CustomerDetailResponseOutput>;
export type CustomerDetailResponseOutputOutput = zod.output<typeof CustomerDetailResponseOutput>;
